import { useAuth } from "@emberly/zenith-client";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useMissionTask } from "../../../../providers/MissionTaskProvider";


export default function GoToMyMissionsDialog() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { missionTask } = useMissionTask();
  const userDoesNotMatch = useMemo(() => !!missionTask && !!user && !missionTask?.execution?.driver?.id?.endsWith(user.sub), [user, missionTask?.execution?.driver?.id]);


  return userDoesNotMatch ? (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">
        {t("goToMyMissionsDialog:title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("goToMyMissionsDialog:description")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={() => navigate("/mymissions", { relative: "path", replace: true })} autoFocus>
          {t("goToMyMissionsDialog:action")}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
}